import Vue from 'vue';
import _ from 'lodash'

import {
  NOTE_CREATE_SET,
  NOTE_GET,
  NOTE_DELETE,
} from '../mutations-types'

const state = {
  notes: null
};

const getters = {
  notes: state => state.notes,
};

const mutations = {
  [NOTE_CREATE_SET](state, note) {
    state.notes.push(note)
  },

  [NOTE_GET](state, collection) {
    Vue.set(state, 'notes', collection);
  },

  [NOTE_DELETE](state, noteId) {
    let index = _.findIndex(state.notes, note => {
      return note.id === noteId;
    });
    state.notes.splice(index, 1);
  },
};

const actions = {
  /**
   * @URLParams
   * none
   * @BodyParams
   * listing_id: integer, required
   * text: string, required
   * **/
  NOTES_CREATE_REQUEST_SET ({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      Vue.axios.post('/note', data)
        .then(response => {
          commit(NOTE_CREATE_SET, response.data.data);
          resolve();
        }).catch(error => {
          reject();
        });
    });
  },
  /**
   * @URLParams
   * none
   * @BodyParams
   * none
   * **/
  NOTES_REQUEST_GET ({ state, commit }, listingId) {
    return new Promise((resolve, reject) => {
      Vue.axios.get('/note/' + listingId)
        .then(response => {
          commit(NOTE_GET, response.data.data);
          resolve();
        }).catch(error => {
          reject();
        });
    });
  },
  /**
   * @URLParams
   * none
   * @BodyParams
   * none
   * **/
  NOTES_REQUEST_DELETE ({ state, commit }, noteId) {
    return new Promise((resolve, reject) => {
      Vue.axios.delete('/note/' + noteId)
        .then(response => {
          commit(NOTE_DELETE, noteId);
          resolve();
        }).catch(error => {
          reject();
        });
    });
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};